import {
  updateTool,
  updateGrade,
  updatePerson,
  updateSchool,
  updateDepartment
} from './formChangeEventHandlers.js';

export function getSchoolSelectConfig() {
  return {
    valueField: 'value',
    labelField: 'label',
    searchField: 'label',
    options: [],
    onChange: (updateSchool)
  };
}

export function getPersonSelectConfig() {
  return {
    valueField: 'value',
    labelField: 'label',
    searchField: 'label',
    optgroupField: 'group',
    sortField: {
      field: 'label',
      direction: 'asc'
    },
    optgroups: [
      {value: 'staffs', label: 'Non-Instructional Staff'},
      {value: 'teachers', label: 'Teaching/Instructional Staff'},
    ],
    options: [],
    onChange: (updatePerson)
  };
}

export function getToolSelectConfig({toolTypes}) {
  let optgroups = [];

  for (const toolTypeId in toolTypes) {
    if (!toolTypes.hasOwnProperty(toolTypeId)) {
      continue;
    }

    optgroups = [...optgroups, {
      value: toolTypeId,
      label: toolTypes[toolTypeId]
    }];
  }

  return {
    valueField: 'value',
    labelField: 'label',
    searchField: 'label',
    optgroupField: 'group',
    optgroups: optgroups,
    options: [],
    onChange: (updateTool)
  };
}

export function getDepartmentSelectConfig() {
  return {
    valueField: 'value',
    labelField: 'label',
    searchField: 'label',
    options: [],
    onChange: (updateDepartment)
  };
}

export function getGradeSelectConfig() {
  return {
    valueField: 'value',
    labelField: 'label',
    searchField: 'label',
    options: [],
    onChange: (updateGrade)
  };
}
